<app-user-editor></app-user-editor>

<router-outlet></router-outlet>